import { Heading, Image, Paragraph, ProductBasket } from '@piggybank/core';
import config from 'configAlias';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import T from 'prop-types';
import React from 'react';
import Standalone from 'srcAlias/standalones/Standalone';
import { getMatchingStandaloneConfig } from 'srcAlias/standalones/utils';
import ErrorBoundary from './ErrorBoundary';
import Segment from './Segment';
import { Optional, Translation } from './locale';

const assets = (() => {
  try {
    return require('assetsAlias/productBasket').default;
  } catch (_) {
    return {};
  }
})();

export const PageContent = ({ errorEvent, productCodes }) => {
  const standaloneConfig = getMatchingStandaloneConfig(config);

  return (
    <>
      <Optional>
        <Translation absolutePath="global.productMarketSectorMappings">
          {mappings => {
            const match = get(
              mappings,
              [productCodes.productCode, productCodes.marketSectorCode],
              false
            );

            if (match) {
              const { displayName, imagePath } = match;
              const imageSrc = assets[imagePath] || null;

              if (imageSrc) {
                return (
                  <ProductBasket
                    imageSlot={
                      <Image
                        alt={displayName}
                        intrinsicSize="200x126"
                        marginBottom={0}
                        src={imageSrc}
                      />
                    }
                    marginBottom={4}
                  >
                    <Paragraph marginBottom={0}>{mappings.heading}</Paragraph>
                    <Heading level={3} marginBottom={0}>
                      {displayName}
                    </Heading>
                  </ProductBasket>
                );
              }
            }

            return null;
          }}
        </Translation>
      </Optional>
      <ErrorBoundary
        appConfig={config.appConfig}
        setError={(data = {}) => errorEvent(data)}
        title="An error occurred"
      >
        {isEmpty(standaloneConfig) ? (
          <Segment
            appConfig={config.appConfig}
            setError={(data = {}) => errorEvent(data)}
          />
        ) : (
          <Standalone
            appConfig={config.appConfig}
            standaloneConfig={standaloneConfig}
          />
        )}
      </ErrorBoundary>
    </>
  );
};

PageContent.propTypes = {
  errorEvent: T.func.isRequired,
  productCodes: T.object,
};
